import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { IncidentCategory, IncidentInternalStatus, IncidentListItem, IncidentPriority, IncidentSeverity, IncidentTriggerProductionLabel } from '@/features/stacktrace/incidents/-query/type';

/**
 * インシデント一覧 (ICD Force グローバルメニュー) のテーブル列ID。
 *
 * 表示項目:
 *   コード / 表題 / 重大度 / 対応ステータス / 優先度 / 分類 / 重大インシデント /
 *   検知時刻 / MTTR / 指揮者 / 影響機能数 / 影響顧客数 / 引き金リリース
 */
export const IncidentTableColumns = {
  CODE: 'CODE',
  TITLE: 'TITLE',
  SEVERITY: 'SEVERITY',
  INTERNAL_STATUS: 'INTERNAL_STATUS',
  PRIORITY: 'PRIORITY',
  CATEGORY: 'CATEGORY',
  IS_MAJOR: 'IS_MAJOR',
  DETECTED_AT: 'DETECTED_AT',
  MTTR: 'MTTR',
  COMMANDER: 'COMMANDER',
  IMPACTED_PRODUCT_NODE_COUNT: 'IMPACTED_PRODUCT_NODE_COUNT',
  IMPACTED_CUSTOMER_COUNT: 'IMPACTED_CUSTOMER_COUNT',
  TRIGGER_PRODUCTION: 'TRIGGER_PRODUCTION'
} as const;
export type IncidentTableColumns = EnumUnion<typeof IncidentTableColumns>;
export type IncidentTableRowData = {
  /** Incident ID（行クリックでの詳細遷移用。列としては表示しない） */
  id: string;
  [IncidentTableColumns.CODE]: string;
  [IncidentTableColumns.TITLE]: string;
  [IncidentTableColumns.SEVERITY]: IncidentSeverity;
  [IncidentTableColumns.INTERNAL_STATUS]: IncidentInternalStatus;
  [IncidentTableColumns.PRIORITY]: IncidentPriority | null;
  [IncidentTableColumns.CATEGORY]: IncidentCategory;
  [IncidentTableColumns.IS_MAJOR]: boolean;
  [IncidentTableColumns.DETECTED_AT]: string | null;
  [IncidentTableColumns.MTTR]: number | null;
  [IncidentTableColumns.COMMANDER]: string | null;
  [IncidentTableColumns.IMPACTED_PRODUCT_NODE_COUNT]: number;
  [IncidentTableColumns.IMPACTED_CUSTOMER_COUNT]: number;
  [IncidentTableColumns.TRIGGER_PRODUCTION]: IncidentTriggerProductionLabel | null;
};
export const convertIncidentItemToTableRow = (item: IncidentListItem): IncidentTableRowData => {
  return {
    id: item.id,
    [IncidentTableColumns.CODE]: item.code,
    [IncidentTableColumns.TITLE]: item.title,
    [IncidentTableColumns.SEVERITY]: item.severity,
    [IncidentTableColumns.INTERNAL_STATUS]: item.internalStatus,
    [IncidentTableColumns.PRIORITY]: item.priority ?? null,
    [IncidentTableColumns.CATEGORY]: item.category,
    [IncidentTableColumns.IS_MAJOR]: item.isMajor,
    [IncidentTableColumns.DETECTED_AT]: item.detectedAt,
    [IncidentTableColumns.MTTR]: item.mttrSeconds,
    [IncidentTableColumns.COMMANDER]: item.commanderPersonName,
    [IncidentTableColumns.IMPACTED_PRODUCT_NODE_COUNT]: item.impactedProductNodeCount,
    [IncidentTableColumns.IMPACTED_CUSTOMER_COUNT]: item.impactedCustomerCount,
    [IncidentTableColumns.TRIGGER_PRODUCTION]: item.triggerProduction
  };
};